import React from 'react';

/**
 * Renders the brand mark experience.
 *
 * @param {object} props - Component properties.
 * @param {*} props.size - size numeric value.
 * @param {*} props.className - class name value.
 * @returns {JSX.Element} The rendered interface.
 */
export default function BrandMark({ size = 'medium', className = '' }) {
  return (
    <span className={`brand-mark brand-mark-${size} ${className}`.trim()} aria-hidden="true">
      <img src="/assets/brand/hobtalk-mark-transparent-192.png" alt="" />
    </span>
  );
}
